/** Helpers puros de permisos Courier (front). Admin implica ambos. */

export const PERMISO_COURIER_SOLICITAR = "Permiso_Courier_Solicitar";
export const PERMISO_COURIER_TERMINAR = "Permiso_Courier_Terminar";
export const PERMISO_DESCARGAR_ETIQUETA_DHL = "Permiso_descargarEtiquetaDHL";

export function isAdminUser(user = {}) {
  return user.isAdmin === true || user.isAdmin === 1 || user.isAdmin === "1";
}

export function canCourierSolicitar(user = {}) {
  if (isAdminUser(user)) return true;
  return Boolean(user[PERMISO_COURIER_SOLICITAR]);
}

export function canCourierTerminar(user = {}) {
  if (isAdminUser(user)) return true;
  return Boolean(user[PERMISO_COURIER_TERMINAR]);
}

export function canCourierAccess(user = {}) {
  return canCourierSolicitar(user) || canCourierTerminar(user);
}

export function canDownloadDhlLabel(user = {}) {
  return Boolean(user[PERMISO_DESCARGAR_ETIQUETA_DHL]);
}

/** Crear el envío real en MyDHL. Mismo permiso que terminar / anular. */
export function canCreateDhlShipment(user = {}) {
  return canCourierTerminar(user);
}
